import React, { memo } from 'react';
import { OrderInfoSectionProps } from './OrderRowTypes';

export const OrderInfoSection = memo<OrderInfoSectionProps>(({ order }) => (
  <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-4">
    <div className="space-y-1">
      <div className="flex items-center gap-2">
        <span className="text-xs font-medium text-gray-500 uppercase tracking-wider">Sipariş</span>
        <span className="px-2 py-1 bg-blue-100 text-blue-800 rounded-lg text-xs font-bold">
          #{order.id}
        </span>
      </div>
      <div className="text-sm font-semibold text-gray-900">
        {order.user_name} {order.user_surname}
      </div>
      <div className="text-xs text-gray-500">
        {order.management} • {order.office}
      </div>
    </div>

    <div className="space-y-1">
      <div className="text-xs font-medium text-gray-500 uppercase tracking-wider">Detaylar</div>
      <div
        className="text-sm text-gray-900"
        style={{
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
        }}
      >
        {order.items_summary || 'Ürün bilgisi yok'}
      </div>
      <div className="flex items-center gap-3 text-xs text-gray-500">
        <span>{order.item_count} ürün</span>
        <span>•</span>
        <span className="font-semibold text-green-600">{order.total_amount} ₺</span>
      </div>
    </div>
  </div>
));

OrderInfoSection.displayName = 'OrderInfoSection';
